import { React } from "react";
import { styled, Typography } from "@mui/material";
import SarahImg from "../../assets/sarah.jpg";
import Footer from "../footer/Footer";

const PageShell = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

const StyledMainContainer = styled("div")(({ theme }) => ({
  width: "min(1120px, 100%)",
  margin: "0 auto",
  [theme.breakpoints.down("lg")]: {
    width: "100%",
  },
}));

const HeroCard = styled("section")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "minmax(240px, 340px) 1fr",
  alignItems: "center",
  gap: "2.25rem",
  background: "rgba(255, 248, 239, 0.82)",
  borderRadius: "2.5rem",
  padding: "2rem",
  boxShadow: "0 22px 50px rgba(95, 58, 38, 0.1)",
  border: "1px solid rgba(159, 104, 72, 0.14)",
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
    padding: "1.25rem",
    borderRadius: "1.75rem",
  },
}));

const StyledTextContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
});

const StyledText = styled(Typography)(({ theme }) => ({
  fontSize: "1.05rem",
  lineHeight: 1.95,
  color: theme.palette.text.secondary,
}));

const StyledImg = styled("img")(({ theme }) => ({
  width: "100%",
  maxWidth: "21rem",
  height: "28rem",
  objectFit: "cover",
  borderRadius: "2rem",
  justifySelf: "center",
  boxShadow: "0 20px 44px rgba(90, 54, 34, 0.16)",
  [theme.breakpoints.down("md")]: {
    height: "24rem",
  },
}));

function About() {
  return (
    <PageShell>
      <StyledMainContainer>
        <HeroCard>
          <StyledImg src={SarahImg} />
          <StyledTextContainer>
            <StyledText>
              <span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                Sarah Quickel,
              </span>{" "}
              my sister, was the most thoughtful and introspective person I
              have ever met. Anyone who is visiting this site most likely knows
              about the tragic nature of her death in December 2022. One of the
              main comforts that has helped me through this time is the amount
              of advice, expression, and her very spirit which Sarah left to us
              through her writings. It is an amazing gift to have had such a
              talented sister who left behind her artwork, journals, and even
              the beginnings of a novel. I decided, along with my family, that
              her work and wisdom should not be contained to just us, but should
              be shared with everyone who had the pleasure of knowing her. I
              wanted to create a site that wasn't something static but something
              emblematic of Sarah's spirit and something that helps everyone to
              have a piece of her every day, or whenever they may need “a dose
              of Sarah”.
            </StyledText>
            <StyledText>
              In the main section of the site there will be a daily post
              displaying an excerpt from her many mediums of expression.
            </StyledText>
            <StyledText>
              While I do have lots of content for this site, I do want to keep
              posting as long as possible. If you have anything you would like
              to contribute, whether it be a personal experience with her,
              artwork, or anything else that reminds you of Sarah, please reach
              out to either my family, or me directly, and I will share it.
            </StyledText>
            <StyledText>
              I also want to send a special thank you to my friend, Max, who
              provided me key assistance throughout the development of this
              site.
            </StyledText>
            <StyledText>
              Love you forever Sis &lt;3 Stephen
            </StyledText>
          </StyledTextContainer>
        </HeroCard>
      </StyledMainContainer>
      <Footer />
    </PageShell>
  );
}

export default About;
